module.exports = __webpack_public_path__ + "img/notice.b83dd01d.png";